import * as React from 'react';
import { useViewportEntries } from '../use-viewport-map';
/**
 * Parent container for the other Viewport components:
 * `<ViewSmall>`, `<ViewMedium>`, `<ViewLarge>`,`<ViewExtraLarge>`
 */
var Viewport = function (_a) {
    var children = _a.children;
    return (React.createElement(React.Fragment, null, useViewportEntries(React.Children.toArray(children).map(function (child) { return [
        child.type.viewSize,
        child.props.children
    ]; }))));
};
export default Viewport;
//# sourceMappingURL=viewport.js.map